interface UserIdentityCellProps {
  nickname?: string | null;
  userId?: string | null;
  avatar?: string | null;
}

export default function UserIdentityCell({ nickname, userId, avatar }: UserIdentityCellProps) {
  const displayName = nickname || userId || "--";
  const accountId = userId || "--";

  return (
    <div className="flex items-center gap-2.5 md:gap-3">
      {avatar ? (
        <img src={avatar} alt="" className="w-8 h-8 md:w-9 md:h-9 rounded-full object-cover shrink-0" />
      ) : (
        <div className="w-8 h-8 md:w-9 md:h-9 rounded-full bg-brand/10 flex items-center justify-center text-brand font-medium text-xs shrink-0">
          {(displayName || "?")[0]}
        </div>
      )}
      <div className="min-w-0">
        <p className="text-text-primary font-medium text-xs md:text-sm truncate">{displayName}</p>
        <p className="text-text-muted text-[11px] md:text-xs truncate">{accountId}</p>
      </div>
    </div>
  );
}
